

import type { DomainDef, DomainId } from "./types";

export const DOMAIN_DEFS: Record<DomainId, DomainDef> = {
  steel: {
    id: "steel",
    name: "Сталь",
    classId: "warrior",
    keyStat: "dexterity",
    description: "Точные удары клинка и защита щитом.",
  },
  blood: {
    id: "blood",
    name: "Кровь",
    classId: "warrior",
    keyStat: "wisdom",
    description: "Жертвенные удары: боль врага становится твоей силой.",
  },

  light: {
    id: "light",
    name: "Свет",
    classId: "priest",
    keyStat: "constitution",
    description: "Исцеление и защита светом.",
  },
  darkness: {
    id: "darkness",
    name: "Тьма",
    classId: "priest",
    keyStat: "intelligence",
    description: "Проклятия и высасывание жизни.",
  },
  nature: {
    id: "nature",
    name: "Природа",
    classId: "priest",
    keyStat: "strength",
    description: "Сила леса и зверей.",
  },

  fire: {
    id: "fire",
    name: "Огонь",
    classId: "wizard",
    keyStat: "strength",
    description: "Разрушительные огненные заклинания.",
  },
  ice: {
    id: "ice",
    name: "Лёд",
    classId: "wizard",
    keyStat: "constitution",
    description: "Контроль и замедление холодом.",
  },
  shadow: {
    id: "shadow",
    name: "Тень",
    classId: "wizard",
    keyStat: "dexterity",
    description: "Обман и поражение из тени.",
  },
};

export const DOMAIN_ORDER: DomainId[] = [
  "steel", "blood", "light", "darkness", "nature", "fire", "ice", "shadow",
];

export function getDomain(id: DomainId): DomainDef {
  const def = DOMAIN_DEFS[id];
  if (!def) throw new Error(`Unknown domain id: ${id}`);
  return def;
}
